import React from "react";

export default function Terms() {
  return (
    <div
      style={{
        background: "#0a0a0a",
        color: "#eee",
        minHeight: "100vh",
        padding: "60px 20px",
        fontFamily: "'IBM Plex Sans', sans-serif",
        lineHeight: 1.6,
      }}
    >
      <h2
        style={{
          color: "#ff77cc",
          textShadow: "0 0 8px rgba(255, 0, 170, 0.6)",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Terms of Purchase
      </h2>

      <div style={{ maxWidth: "680px", margin: "0 auto", fontSize: "14px" }}>
        <p><strong>No Refunds:</strong> All purchases are final. Due to the nature of this interactive art project, we do not offer refunds for any reason.</p>

        <p><strong>Understanding the Experience:</strong> Each tile purchase contributes to a slow, suspenseful reveal of a hidden face. Some tiles may appear blank or subtle depending on where they land on the canvas. This is part of the concept.</p>

        <p><strong>Purchasing Does Not Guarantee Visibility:</strong> Not all purchases reveal something instantly. Some may unlock sections of the image that appear dark or abstract. The mystery is the point.</p>

        <p><strong>Disputes and Chargebacks:</strong> Attempting to reverse a charge for a completed tile purchase may result in a ban from participating in future phases of the project.</p>

        <p><strong>Participation Consent:</strong> By purchasing, you acknowledge your understanding of the experience and accept the outlined terms.</p>

        <p style={{ marginTop: "24px", color: "#888" }}>
          This is a conceptual digital art piece and does not constitute a typical transaction for a physical good.
        </p>
      </div>
    </div>
  );
}
